module.exports = __webpack_public_path__ + "static/media/06_hero_desktop.b3e7a94e.jpg";